import { cn } from "@/lib/utils";

/** 11px caption needs 14px of bar height; "100%" plus inset needs ~36px of width. */
export function fitsProgressLabel(width: number, height: number) {
  return height >= 14 && width >= 36;
}

/** Percent-complete text pinned to the left edge inside a task bar. */
export function BarProgressLabel({ percent, critical }: { percent: number; critical?: boolean }) {
  return (
    <span
      className={cn(
        "pointer-events-none absolute inset-y-0 left-0 z-[2] flex items-center text-[11px] leading-none font-normal tabular-nums text-bar-label",
        critical ? "pl-1.5" : "pl-1",
      )}
    >
      {Math.round(percent)}%
    </span>
  );
}
